import { call, put, takeLatest } from "redux-saga/effects";

import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import {
  fetchCorporateTripFailure,
  fetchCorporateTripSuccess,
} from "../slices/CorporateTripSlices";
import { FETCH_GETCORPORATE_TRIP } from "../actions/CorporateTripAction";
import notification from "antd/es/notification";

export function* fetchhCorTripSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchCorporateTripSuccess(result));
    else {
      yield put(fetchCorporateTripFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchCorporateTripFailure(error.message));
  }
}
export default function* corporatetripSaga() {
  yield takeLatest(FETCH_GETCORPORATE_TRIP, fetchhCorTripSaga);
}
